import { BrandCard } from "@shltelemedicine/shl-ui-lib";
import styles from "./ChangePassword.module.css";
import ChangePasswordForm from "./ChangePasswordForm/ChangePasswordForm";
import Disclaimer from "../Disclaimer/Disclaimer";

const ChangePassword = () => {
  return (
    <>
      <BrandCard className={styles.wrapper}>
        <div className="d-flex flex-column">
          <ChangePasswordForm />
        </div>
      </BrandCard>

      <div className={`${styles.warning} font-md text-center`}>
        <p className="mt-3 mb-0">
          <Disclaimer />
        </p>
      </div>
    </>
  );
};

export default ChangePassword;
